export default function redirectPostUrl(resp = {}) {
  return {
    type: 'REDIRECT_POST_URL',
    status: resp.status,
    redirect: resp.redirect
  };
}



// WEBPACK FOOTER //
// ./src/redux/action_creators/redirect_action_creators.js